import { createAsyncThunk } from '@reduxjs/toolkit';

import USER_API from './user.api';

export const getListUsers = createAsyncThunk<any, any>(
  'user',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await USER_API.listUsersAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);

export const createUser = createAsyncThunk<any, any>(
  'create_user',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await USER_API.createUserAPI(data);
      return res
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);
export const updateUser = createAsyncThunk<any, any>(
  'update_user',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await USER_API.updateUserAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);

export const deleteUser = createAsyncThunk<any, any>(
  'delete_user',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await USER_API.deleteUserAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);
